module.exports = __webpack_public_path__ + "static/media/Medicine Product Name.2e37e975.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cont/Medicine Product Name.png
// module id = 1184
// module chunks = 0